import axios from "axios";
import { FETCH_PEOPLE } from "../constants";

const setPeople = people => ({
  type: FETCH_PEOPLE,
  people
});

export const fetchPeople = () => dispatch => {
  fetch('/input-data.json')
    .then(res => res.json())
    .then(data => {
      dispatch(setPeople(data["sections_peoples"]));
    })
    .catch(err => {
      console.log(err);
      throw new Error(err);
    });
};
